<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Health plan and benefits</h1>
                </div>
            </div>    
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                <el-form-item class="no-scroll" prop="has_401k" :required="true" label="Do you have a 401k?">
                    <el-select class="401k-select" style="width: 100%"
                        v-model="formsData.userForm.has_401k.value" placeholder="Please select" popper-class="normal-select">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="no-scroll" prop="pre_tax_percentage_401k" :required="true" label="What percentage contribution pre-tax would you like to make to your 401K?" v-if="formsData.userForm.has_401k.value === 1">
                    <el-input v-model="formsData.userForm.pre_tax_percentage_401k.value" autocomplete="off" placeholder="Enter the percentage" />
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="blue" @click="goNext('userForm')" :disabled="isButtonDisabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {
    onMounted,
    inject,
    computed
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import { ElMessageBox } from "@/components/Vendor/Element";

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const userData = $store.getters.GET_USER_DATA;
        console.log("🚀 ~ setup ~ userData:", userData)
        const formsDataArray = {
            userForm: {
                has_401k: {
                    value: userData.settings.has401K,
                    valueImportant: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'has401k', callback, setFormValidation);
                        },
                    }]
                },
                pre_tax_percentage_401k: {
                    value: userData.settings.preTaxPercentage401k,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'preTaxPercentage401k', callback, setFormValidation);
                        },
                    }]
                },
            }
        };

        const goBack = () => {
            $router.push({
                name: 'auth_tax_and_payments'
            })
        };

        const isButtonDisabled = computed(() => {
            if(formsData.userForm.has_401k.value === 0) {
                return false;
            }
            return formsData.userForm.disabled;
        });

        const goNext = (formName) => {
            $store.dispatch('addAuthPageBack', $route.name);
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            let formValues = getFormValues(formName);
                            formValues = {
                                    ...formValues,
                                    onboarding_step: "health_plan_and_benefits_401k"
                                };
                            if(formValues.has_401k === 0) {
                                formValues.pre_tax_percentage_401k = '';
                            }
                            await $store.dispatch('SAVE_USER_DATA', formValues);
                            $router.push({
                                name: 'auth_tax_payments_bank_details',
                            });
                        } catch (error) {
                            console.error('Error submitting form:', error);
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log('error submit!!');
                    return false;
                }
            });
        };
        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    $router.push({
                        name: 'auth_tax_payments_bank_details',
                    })
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }



        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            checkFormValidation('userForm', false);
        });


        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            checkFormValidation,
            goBack,
            goNext,
            isButtonDisabled,
            skip
        }
    },
}
</script>